import React, { useId, useState } from 'react';

import { useMarkForRegeneration } from "api/api-hooks/reports-hooks";
import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts';
import { Button } from "primereact/button";
import { ConfirmPopup } from "primereact/confirmpopup";
import { GeneratedDashboardReportResponse } from "../../../api/model/dashboard/GeneratedDashboardReportResponse";

const MarkForRegeneration = (props: {
    rowData: GeneratedDashboardReportResponse
}) => {
    const id = useId();

    const [popup, setPopup] = useState(false);

    const {mutate: markForRegeneration, isPending: markedForRegenerationLoading} = useMarkForRegeneration({
        onSuccess: () => {
            easasAlert({
              summary: "Report marked for regeneration",
              severity: "success",
              life: 3000,
            });
        },
        onFailure: () => {
            easasAlert({
              summary: "Failed to mark report for regeneration",
              severity: "error",
              life: 3000,
            });
        }
    });

    const accept = () => {
        markForRegeneration({genId: [props.rowData.id], lazy: false})
    };

    return (<div className="flex align-items-center">
            <ConfirmPopup target={document.getElementById(id) ?? undefined}
                          visible={popup} onHide={() => setPopup(false)}
                          message="Mark for regeneration?"
                          icon="pi pi-question-circle" accept={accept}/>
            <Button icon="fa fa-retweet"
                    id={id}
                    className="p-button-rounded p-button-text p-button-sm"
                    loading={markedForRegenerationLoading}
                    onClick={() => setPopup(true)}
            />
        </div>
    ) || null;
};

export default MarkForRegeneration;